import { FC, useEffect } from 'react';
import { CustomerPageView } from './CustomerPageView';

import { useListStore } from './hooks';

export const CustomerPage: FC = () => {
  const { finalUpdateTime, fetchCustomers } = useListStore();

  useEffect(() => {
    void fetchCustomers();
  }, [finalUpdateTime, fetchCustomers]);

  return <CustomerPageView />;
};
